<mat-form-field class="form-field" [formGroup]="formGroup" [matTooltip]="!canLock ? (lockedText | async) : ''">
  <mat-select [formControlName]="documentInformationType" [placeholder]="titleText">
    <mat-option *ngFor="let option of options" [value]="option">
      {{ option | docInfoValueDisplayName: valueDisplayName }}
    </mat-option>
  </mat-select>
  <mat-hint *ngIf="hintText">{{ hintText }}</mat-hint>
</mat-form-field>
